/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { EventMessage, EventType, LogLevel, PublicClientApplication } from '@azure/msal-browser';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID as string,
    authority: process.env.REACT_APP_AZURE_AUTHORITY as string,
    redirectUri: (window.location.origin.toLowerCase() === process.env.REACT_APP_CSTT_1 ? process.env.REACT_APP_CSTT_1 : process.env.REACT_APP_AZURE_REDIRECT_URI) as string
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: any, containsPii: any) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            console.warn(message);
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
const apiScope: string = `api://${process.env.REACT_APP_API_AZURE_CLIENT_ID}/access_as_user`;
export const loginRequest = {
  scopes: []
};

export const apiRequest = {
  scopes: [
    apiScope,
  ],
};

export const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.addEventCallback((eventMessage: EventMessage) => {
  if (eventMessage.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
    msalInstance.loginRedirect(loginRequest);
  }
});